var _path, _path2, _path3, _path4, _path5, _path6, _rect, _line, _line2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculadoraProgressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 84,
    viewBox: "0 0 114 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.6221 9.875L74.874 15.6231",
    stroke: "white",
    strokeWidth: 1.95968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8735 9.875L80.6216 15.6231",
    stroke: "white",
    strokeWidth: 1.95968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4058 51.293H84.1154V71.3252C84.1154 75.0131 81.1259 78.0026 77.438 78.0026H57.4058V51.293Z",
    fill: "#4676FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4058 51.293L30.6961 51.293L30.6961 31.2607C30.6961 27.5729 33.6857 24.5833 37.3735 24.5833L57.4058 24.5833L57.4058 51.293Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1155 51.293L57.4058 51.293L57.4058 24.5833L77.4381 24.5833C81.1259 24.5833 84.1155 27.5729 84.1155 31.2607L84.1155 51.293Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4058 78L37.3735 78C33.6857 78 30.6961 75.0104 30.6961 71.3226L30.6961 51.2903L57.4058 51.2903L57.4058 78Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.696,
    y: 25.582,
    width: 51.4194,
    height: 51.4194,
    rx: 5.67742,
    stroke: "#2047AE",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56.7363,
    y1: 24.582,
    x2: 56.7363,
    y2: 78.0014,
    stroke: "#2047AE",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 84.1189,
    y1: 51.4297,
    x2: 32.0693,
    y2: 51.6064,
    stroke: "#2047AE",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.939 39.6523H75.8968",
    stroke: "#2047AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.939 61.5625H75.8968",
    stroke: "#2047AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.939 67.0391H75.8968",
    stroke: "#2047AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7507 34.168V45.8404",
    stroke: "#2047AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9141 40.0039H50.5865",
    stroke: "#2047AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5559 60.2109L40.3022 68.4646",
    stroke: "#2047AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.302 60.2109L48.5557 68.4646",
    stroke: "#2047AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2256 48V58.4516",
    stroke: "white",
    strokeWidth: 1.95968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 53.2266H22.4514",
    stroke: "white",
    strokeWidth: 1.95968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.053 64.0195L98.0176 68.0549",
    stroke: "#2047AE",
    strokeWidth: 1.95968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0168 64.0195L102.052 68.0549",
    stroke: "#2047AE",
    strokeWidth: 1.95968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7068 33.8555L8.99993 33.8555",
    stroke: "#2047AE",
    strokeWidth: 1.95968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8528 31L11.8528 36.7069",
    stroke: "#2047AE",
    strokeWidth: 1.95968,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3355 7.59315C18.2355 8.32092 16.4593 9.79235 15.3315 11.7383C14.2767 13.5582 13.88 15.6354 14.1789 17.7729C14.2522 18.2968 14.5527 19.3839 14.7654 19.8946C15.5734 21.8342 16.9379 23.3928 18.7318 24.4252C20.5764 25.4869 22.6335 25.8801 24.7672 25.5791C25.2912 25.5051 26.3792 25.2044 26.8888 24.9926C29.9046 23.7394 32.0267 21.0676 32.5549 17.8587C32.8745 15.9177 32.5354 13.8339 31.6123 12.0659C29.8195 8.63194 25.9778 6.64292 22.15 7.16672C21.5898 7.24338 20.8283 7.42233 20.3355 7.59315ZM26.8774 12.0865C27.047 12.1147 27.3038 12.2667 27.3948 12.3928C27.4807 12.5118 27.5558 12.838 27.5345 12.9996C27.5212 13.101 26.9592 14.109 25.6722 16.3399C23.655 19.8365 23.7172 19.7441 23.3373 19.812C23.2372 19.83 23.092 19.8328 23.0146 19.8184C22.9347 19.8035 22.1509 19.3724 21.1989 18.8198C19.6635 17.9284 19.5165 17.8345 19.4343 17.6925C19.2495 17.3734 19.2729 17.0139 19.4953 16.7568C19.6611 16.5651 19.8413 16.4794 20.0961 16.4713C20.2836 16.4653 20.3414 16.4939 21.5937 17.2121L22.8962 17.9592L24.5234 15.143C25.5656 13.3391 26.1896 12.296 26.2593 12.2412C26.4078 12.1246 26.6865 12.0548 26.8774 12.0865Z",
    fill: "#2047AE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7582 34.5845C94.4683 35.0315 93.3772 35.9353 92.6845 37.1307C92.0366 38.2485 91.7929 39.5245 91.9765 40.8374C92.0215 41.1592 92.2061 41.827 92.3368 42.1407C92.833 43.3321 93.6712 44.2895 94.7731 44.9236C95.9062 45.5758 97.1697 45.8173 98.4804 45.6324C98.8023 45.5869 99.4705 45.4022 99.7836 45.2721C101.636 44.5023 102.94 42.8612 103.264 40.8901C103.46 39.6979 103.252 38.4179 102.685 37.3318C101.584 35.2225 99.224 34.0008 96.8728 34.3225C96.5287 34.3696 96.0609 34.4795 95.7582 34.5845ZM99.7766 37.3445C99.8808 37.3618 100.038 37.4552 100.094 37.5326C100.147 37.6058 100.193 37.8061 100.18 37.9054C100.172 37.9677 99.8268 38.5868 99.0363 39.9572C97.7972 42.105 97.8354 42.0482 97.602 42.09C97.5406 42.101 97.4514 42.1027 97.4039 42.0939C97.3548 42.0847 96.8733 41.8199 96.2886 41.4805C95.3454 40.9329 95.2551 40.8752 95.2046 40.788C95.0911 40.5921 95.1055 40.3712 95.2421 40.2133C95.3439 40.0955 95.4546 40.0429 95.6112 40.0379C95.7263 40.0342 95.7618 40.0518 96.531 40.493L97.3311 40.9519L98.3306 39.222C98.9708 38.1139 99.3541 37.4732 99.3969 37.4396C99.4881 37.3679 99.6593 37.3251 99.7766 37.3445Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadoraProgressIcon);
export default __webpack_public_path__ + "static/media/calculadora-progress-icon.59832749230643588b0b343c1ec60ae3.svg";
export { ForwardRef as ReactComponent };